// Review platforms — extensible list. Add a new object with `enabled: true`
// and it appears automatically in <GoogleReviews />'s "See my reviews" / "Leave
// a review" areas — no component changes needed.
//
// Each platform provides:
//   name          — human label ("Google", "Facebook", …)
//   key           — machine slug, used in test IDs and GA event params
//   viewProfileUrl — the public reviews page URL (opens in a new tab)
//   writeReviewUrl — the "write a review" deep link (opens in a new tab)
//   enabled       — false = hidden entirely (structure kept for later)
//   viewEventName  — GA4 event fired when the "see reviews" button is clicked
//   writeEventName — GA4 event fired when the "write a review" button is
//                    clicked. These events must NOT be mapped to Meta
//                    standard events in analytics.js (owner rule).

// Owner-swap points — the two Google URLs live in /src/constants.js next to
// the PHONE_* constants (single source of truth). Re-exported here so any
// code that used to import them from this module keeps working unchanged.
// Verified 2026-08-31: both short links resolve to the FairFix Google
// Business Profile with a 200.
import { GOOGLE_REVIEWS_URL, GOOGLE_REVIEW_WRITE_URL } from './constants';
export { GOOGLE_REVIEWS_URL, GOOGLE_REVIEW_WRITE_URL };

export const REVIEW_PLATFORMS = [
  {
    key: 'google',
    name: 'Google',
    enabled: true,
    viewProfileUrl: GOOGLE_REVIEWS_URL,
    writeReviewUrl: GOOGLE_REVIEW_WRITE_URL,
    viewEventName: 'google_reviews_click',
    writeEventName: 'google_review_write_click',
  },
  // Structure placeholder for future platforms. Flip `enabled: true` and
  // paste in URLs — no code change beyond this file is needed.
  {
    key: 'facebook',
    name: 'Facebook',
    enabled: false,
    viewProfileUrl: null,
    writeReviewUrl: null,
    viewEventName: 'facebook_reviews_click',
    writeEventName: 'facebook_review_write_click',
  },
];

// Convenience — the primary (Google) platform, used by the compact rating
// badge on the service pages.
export const PRIMARY_REVIEW_PLATFORM =
  REVIEW_PLATFORMS.find((p) => p.enabled) || REVIEW_PLATFORMS[0];
